import { render, staticRenderFns } from "./SimpleCode.vue?vue&type=template&id=2ce6ba30&scoped=true"
import script from "./SimpleCode.vue?vue&type=script&lang=js"
export * from "./SimpleCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce6ba30",
  null
  
)

export default component.exports